import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

export default function ProductDetail() {
  const { id }       = useParams();
  const navigate     = useNavigate();
  const [produto,    setProduto]    = useState(null);
  const [error,      setError]      = useState('');
  const [adding,     setAdding]     = useState(false);
  const [imgError,   setImgError]   = useState(false);
  const [added,      setAdded]      = useState(false);

  useEffect(() => {
    api.get(`/produtos/${id}`)
      .then(r => setProduto(r.data))
      .catch(() => setError('Não foi possível carregar o produto.'));
  }, [id]);

  async function addToCart() {
    setAdding(true);
    try {
      await api.post('/cart/add', produto);
      setAdded(true);
      setTimeout(() => navigate('/carrinho'), 800);
    } catch {
      setError('Não foi possível adicionar ao carrinho.');
    } finally {
      setAdding(false);
    }
  }

  if (!produto && !error) return (
    <div style={{ textAlign: 'center', padding: '60px 0', color: '#90a4ae', fontFamily: 'Poppins, sans-serif' }}>
      <i className="fas fa-spinner fa-spin fa-2x" />
    </div>
  );

  return (
    <main style={{ padding: '28px 20px', maxWidth: 900, margin: '0 auto', fontFamily: 'Poppins, sans-serif' }}>

      {/* Breadcrumb */}
      <div style={{ marginBottom: 20, fontSize: '0.85rem', color: '#90a4ae', display: 'flex', alignItems: 'center', gap: 6 }}>
        <Link to="/produtos" style={{ color: '#1e90ff', textDecoration: 'none' }}>
          <i className="fas fa-arrow-left" style={{ marginRight: 4 }} />Cursos
        </Link>
        {produto && <><span>›</span><span style={{ color: '#475569' }}>{produto.nome}</span></>}
      </div>

      {error && <div className="alert-error" style={{ marginBottom: 20 }}>{error}</div>}

      {produto && (
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 32,
          background: '#fff',
          borderRadius: 20,
          padding: 28,
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        }}>

          {/* Imagem */}
          <div style={{
            background: '#f1f5f9',
            borderRadius: 14,
            overflow: 'hidden',
            aspectRatio: '4/3',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {produto.imagem && !imgError ? (
              <img
                src={`/uploads/produtos/${produto.imagem}`}
                alt={produto.nome}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onError={() => setImgError(true)}
              />
            ) : (
              <i className="fas fa-graduation-cap" style={{ fontSize: '4rem', color: '#cbd5e1' }} />
            )}
          </div>

          {/* Info */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <h1 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#1a2a4a', margin: 0, lineHeight: 1.25 }}>
              {produto.nome}
            </h1>

            <div style={{ fontSize: '2rem', fontWeight: 800, color: '#1e90ff' }}>
              {produto.precoFormatado}
            </div>

            {(produto.descricao_completa || produto.descricao) && (
              <p style={{ color: '#475569', fontSize: '0.95rem', lineHeight: 1.75, fontWeight: 400, flex: 1 }}>
                {produto.descricao_completa || produto.descricao}
              </p>
            )}

            {/* Arquivos disponíveis */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {produto.video_file && (
                <span style={{ padding: '4px 12px', background: '#ede9fe', color: '#7c3aed', borderRadius: 20, fontSize: '0.78rem', fontWeight: 700 }}>
                  <i className="fas fa-video" style={{ marginRight: 4 }} />Vídeo incluído
                </span>
              )}
              {produto.audio_file && (
                <span style={{ padding: '4px 12px', background: '#d1fae5', color: '#059669', borderRadius: 20, fontSize: '0.78rem', fontWeight: 700 }}>
                  <i className="fas fa-headphones" style={{ marginRight: 4 }} />Áudio incluído
                </span>
              )}
              {produto.file_name && (
                <span style={{ padding: '4px 12px', background: '#fef3c7', color: '#d97706', borderRadius: 20, fontSize: '0.78rem', fontWeight: 700 }}>
                  <i className="fas fa-file-pdf" style={{ marginRight: 4 }} />Material incluído
                </span>
              )}
            </div>

            <button
              onClick={addToCart}
              disabled={adding || added}
              style={{
                padding: '14px 28px',
                background: added ? '#10b981' : 'linear-gradient(135deg, #1e90ff, #16c2fb)',
                color: '#fff', border: 'none', borderRadius: 12,
                fontFamily: 'Poppins, sans-serif',
                fontSize: '1rem', fontWeight: 700, cursor: adding ? 'not-allowed' : 'pointer',
                transition: 'opacity 0.2s',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              }}
            >
              <i className={`fas fa-${added ? 'check' : adding ? 'spinner fa-spin' : 'shopping-cart'}`} />
              {added ? 'Adicionado! Redirecionando...' : adding ? 'Adicionando...' : 'Adicionar ao carrinho'}
            </button>
          </div>
        </div>
      )}

      {/* Responsive override */}
      <style>{`
        @media (max-width: 640px) {
          .product-detail-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </main>
  );
}
